import chipsApi from "../js/chips-api";

export default function reloadForChecksum(minutes = 10) {
    const paths = window.location.pathname.split("/")
    const key = paths.filter((path) => path).join("-")

    const checksumKey = `page-checksum-${key}`
    const checksum = Date.now()
    const last = localStorage.getItem(checksumKey)
    if (last) {
        if (parseInt(last) + minutes * 60 * 1000 <= checksum) {
            localStorage.setItem(checksumKey, checksum)
            chipsApi.abortController.abort()
            window.location.reload(true)
        }
    } else {
        // initialize
        localStorage.setItem(checksumKey, checksum)
    }
}
